import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col, Table, Pagination } from "react-bootstrap";
import apiService from "./services/api.service";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as moment from 'moment';
import CustomerReqTableComponent from "./CustomerReqTable";
import CompanyOrders from "./companyComponents/CompanyOrders";
import UserPersonalDetailsForm from "./UserPersonalDetailsForm";
import { useDispatch, useSelector } from "react-redux";
import { setCompany, setCompanyUser, setWorkers } from "./Redux/companyReducer";
import { Fragment } from "react";
import { setUser } from "./Redux/userReducer";
import { OrderStatus } from "./data/enums";

function MyAccountComponent() {

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });
  const dispatch = useDispatch()
  const [lang, setLang] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const history = useHistory();
  const [thisAccountCustomer, setThisAccountCustomer] = useState(null);
  const [allOrders, setallOrders] = useState([]);
  const [allCustomerRequests, setallCustomerRequests] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const TextAreaMaxLength = t("giftTextAreaMaxLength");
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pages, setPages] = useState(1)
  const companyUser = useSelector((state) => state.company.companyUser)
  const company = useSelector((state) => state.company.company)
  const loggedUser = useSelector((state) => state.user.user)
  const pageSize = 10;


  let items = [];
  for (let number = 1; number <= pages; number++) {
    items.push(
      <Pagination.Item key={number} active={number === currentPage} onClick={() => setCurrentPage(number)}>
        {number}
      </Pagination.Item>,
    )
  }

  useEffect(() => {
    setallOrders([])
    if (company && companyUser) {
      getCompanyOrders(companyUser.companyId, chainId)
    } else {
      if (thisAccountCustomer) {
        getOrders(thisAccountCustomer.customerId, chainId);
      }
    }
  }, [currentPage])

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");

    if (loggedUser) {
      findCustomer(loggedUser.email, loggedUser.id, true);
    }
    else {
      logout();
    }


  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  useEffect(() => {
    if (thisAccountCustomer) { getAllCustomerRequests(thisAccountCustomer.customerId, chainId); }

  }, []);

  const findCustomer = (email, customerId, isGetOrders) => {

    apiService.getCustomer(email).then(
      (response) => {

        if (response.data.data && response.data.data.length > 0) {
          const customer = response.data.data.find((c) => c.customerId == customerId)
          if (!customer) {
            logout()
          } else {
            if (customerId != customer.customerId) {
              logout();
            } else {
              setThisAccountCustomer(response.data.data[response.data.data.length - 1]);
              if (company && companyUser) {
                dispatch(setCompanyUser(response.data.data[response.data.data.length - 1]))
              }
              if (isGetOrders) {
                getOrders(customerId, new URLSearchParams(location.search).get("chainid"));
              }
            }
          }
        }
        else {
          logout();
        }
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );

  }

  const logout = () => {
    dispatch(setUser(null))
    if (company && companyUser) {
      dispatch(setCompanyUser(null))
      dispatch(setCompany(null))
      dispatch(setWorkers([]))
      history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang") || "eng"}`);
    } else {
      history.push(`/login?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang") || "eng"}`);
    }
  }

  const showSection = (section) => {
    var myAccountSections = [];
    myAccountSections = document.getElementsByClassName("account-section");
    for (let index = 0; index < myAccountSections.length; index++) {
      const element = myAccountSections[index];
      element.classList.remove("hidden");
      element.classList.add("hidden");
    }

    document.getElementById(section).classList.remove("hidden");


    switch (section) {
      case "personalDtlTab":
        fillInAllFields(thisAccountCustomer.customerFirstName + " " + thisAccountCustomer.customerLastName, thisAccountCustomer.customerEmail, thisAccountCustomer.customerPhone, thisAccountCustomer.customerIdentification);
        break;
      case "ordersTab":
        getOrders(thisAccountCustomer.customerId, chainId);

        break;
      case "contactformTab":
        fillInAllFields(thisAccountCustomer.customerFirstName + " " + thisAccountCustomer.customerLastName, thisAccountCustomer.customerEmail, thisAccountCustomer.customerPhone, thisAccountCustomer.customerIdentification);
        getAllCustomerRequests(thisAccountCustomer.customerId, chainId);
        break;

      default:
        break;
    }
  }


  const clearText = (id) => {
    document.getElementById(id).value = "";
    var countfield = document.getElementById("counter");
    countfield.innerHTML = "0/" + TextAreaMaxLength;
  };

  const textCounter = (field, field2, maxlimit) => {
    var countfield = document.getElementById(field2);
    var textarea = document.getElementById(field);
    if (textarea.value.length > maxlimit) {
      textarea.value = textarea.value.substring(0, maxlimit);
      return false;
    }
    else {
      countfield.innerHTML = textarea.value.length + "/" + maxlimit;
    }
  }
  const OrdersWithoutInProgress = () => {
    return `
    ${OrderStatus.Used},
    ${OrderStatus.Pending},
    ${OrderStatus.Redeemed},
    ${OrderStatus.Reserved},
    ${OrderStatus.Cancelled},
    ${OrderStatus.UsedPartially},
    ${OrderStatus.RedemptionPending},
    ${OrderStatus.CancellationPending},
    ${OrderStatus.CancellationRefunded},`
  }

  const getCompanyOrders = (companyId, chainId) => {
    setLoading(true)
    apiService.getOrders({
      chainId: chainId,
      pageSize: pageSize,
      companyId: companyId,
      pageNumber: currentPage,
      groupOrders: "true",
      orderByColumn: "OrderPlacementDate",
      orderStatusIdsCSV: OrdersWithoutInProgress()
    }).then(
      (response) => {
        if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0) {
          let allOrdersWithoutInProgress = response.data.data
          if (response.data.data.length) {
            setPages(response.data.data[0].totalCount / 10)
            getOrderRedeemItem(allOrdersWithoutInProgress);
          }
          setLoading(false)
        }
        else {
          setLoading(false)
          setallOrders([]);
        }
      },
      (error) => {
        setLoading(false)
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    )
  }
  const getOrders = (mycustomerId, mychainId) => {
    if (company && companyUser) {
      getCompanyOrders(company.companyId, chainId)
    } else if (mycustomerId && mycustomerId > 0) {
      apiService.getOrders({
        chainId: mychainId,
        pageSize: pageSize,
        groupOrders: "false",
        pageNumber: currentPage,
        customerId: mycustomerId,
        orderStatusIdsCSV: OrdersWithoutInProgress()
      }).then(
        (response) => {
          if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0) {
            let allOrdersWithoutInProgress = response.data.data;
            getOrderRedeemItem(allOrdersWithoutInProgress);
            setPages(response.data.data[0].totalCount / 10)
          }
          else {
            setallOrders([]);
          }

        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    }
  }

  const getAllCustomerRequests = (mycustomerId, mychainId) => {

    if (mycustomerId && mycustomerId > 0) {
      apiService.getCustomerRequests(mycustomerId, mychainId).then(
        (response) => {
          if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0) {
            let allCustomerRequests = response.data.data;

            setallCustomerRequests(allCustomerRequests);
          }
          else {
            setallCustomerRequests([]);
          }

        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    }
  }


  const submitForm = (data) => {

    let valid = true;
    let errorMsg = "";

    if (!valid) {
      errorMsg = t("CheckAllFields");
      alert(errorMsg);
    }
    else {
      updateCustomerDetails(thisAccountCustomer.customerId, data.fullNameInput, data.EmailInput, data.PhoneInput);
    }
  };

  const submitContactForm = (data) => {

    let valid = true;
    let errorMsg = "";

    if (!valid || data.MessageContactInput === "") {
      errorMsg = t("CheckAllFields");
      alert(errorMsg);
      setErrorMessage(errorMsg);
      setTimeout(() => {
        setErrorMessage("");
      }, 4000);

    }
    else {
      if (data.MessageContactInput) {
        saveCustomerRequest(data.fullNameContactInput, data.EmailContactInput, data.PhoneContactInput, data.MessageContactInput);
        getAllCustomerRequests(thisAccountCustomer.customerId, chainId);
      }
    }
  };

  const fillInAllFields = (fullname, email, phone, passport) => {
    setValue("fullNameInput", fullname, { shouldDirty: true });
    setValue("PhoneInput", phone, { shouldDirty: true });
    setValue("EmailInput", email, { shouldDirty: true });
    setValue("PassportInput", passport, { shouldDirty: true });
    setValue("fullNameContactInput", fullname, { shouldDirty: true });
    setValue("PhoneContactInput", phone, { shouldDirty: true });
    setValue("EmailContactInput", email, { shouldDirty: true });

  };


  const updateCustomerDetails = (customerId, fullname, email, phone) => {
    apiService
      .updateCustomer(customerId, fullname, email, phone)
      .then((res) => {
        if (res) {
          dispatch(setUser(null))
          let loggedUser =
          {
            id: customerId,
            email: email
          }
          dispatch(setUser(loggedUser))
          setErrorMessage(t("customerDetailsUpdateSuccess"));
          findCustomer(email, loggedUser.id, false)
        }
        else {
          setErrorMessage(t("customerDetailsUpdateFailure"));
        }

        setTimeout(() => {
          setErrorMessage("");
        }, 4000);

      })
      .catch((err) => {
        console.error(err);
      });

  };


  const saveCustomerRequest = (fullname, email, phone, message) => {
    apiService
      .insertContactFormReq(fullname, phone, email, message, chainId, thisAccountCustomer.customerId)
      .then((res) => {
        if (res) {

          setErrorMessage(t("customerReqSendSuccess"));
        }
        else {
          setErrorMessage(t("customerReqSendFailure"));
        }

        setTimeout(() => {
          setErrorMessage("");
        }, 4000);

      })
      .catch((err) => {
        console.error(err);
      });

  };


  const getOrderRedeemItem = (allOrdersWithoutInProgress) => {

    for (var i = 0; i < allOrdersWithoutInProgress.length; i++) {

      let currentOrder = allOrdersWithoutInProgress[i];

      if (currentOrder.orderId && currentOrder.products && currentOrder.products.length && currentOrder.products[0].productId > 0) {
        apiService.getOrderRedeemItems(chainId, currentOrder.orderId, currentOrder.products[0].productId).then(
          (response) => {
            if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0) {
              currentOrder.RedeemItem = response.data.data;

              for (var i = 0; i < currentOrder.RedeemItem.length; i++) {
                let curItem = currentOrder.RedeemItem[i];

                if (curItem.propertyId > 0) {
                  curItem.propertyName = curItem.propertyId;

                  apiService.getPropertyById(chainId, curItem.propertyId).then(
                    (response) => {
                      if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0 && response.data.data[0].propertyTranslations.length > 0) {
                        curItem.propertyName = response.data.data[0].propertyTranslations[0].propertyName;


                      }
                      setTimeout(() => {
                        setallOrders(allOrdersWithoutInProgress);
                      }, 900);

                    },
                    (error) => {
                      const _content =
                        (error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        error.message ||
                        error.toString();
                    }
                  );
                }
              }


            }

          },
          (error) => {
            const _content =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
        setTimeout(() => {
          setallOrders(allOrdersWithoutInProgress);
        }, 1000);
      }



    }
  }



  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return moment(result).format('DD/MM/YYYY');
  }

  const getStatusNameById = (id) => {
    let status = "";
    switch (id) {
      case 0: status = t("Cancelled"); break;
      case 1: status = t("Reserved"); break;
      case 2: status = t("InProcess"); break;
      case 3: status = t("Used"); break;
      case 4: status = t("Cancellanionpending"); break;
      case 5: status = t("Cancellanionrefunded"); break;
      case 6: status = t("Redemptionpending"); break;
      case 7: status = t("Redeemed"); break;
      case 8: status = t("UsedPartially"); break;
      case 9: status = t("Pending"); break
      default: status = t("Reserved");
    }
    return status;
  }

  const getTotalRedeemedPerOrder = (RedeemItem, originalPrice, currency) => {
    if (RedeemItem) {
      let totalRedeemedAmount = RedeemItem.reduce((a, v) => a = a + v.redeemAmount, 0);
      let lefttoredeem = originalPrice - totalRedeemedAmount;
      return lefttoredeem + " " + currency;
    }
  }

  const getRedeemHistory = (RedeemItem, originalPrice, currency) => {
    let hisHtml = "";
    if (RedeemItem) {
      hisHtml = RedeemItem.map((currentItem, ind) => {
        return <div key={ind + "-or"} className={'hist-row-' + currentItem.orderId + ' hidden'}><div className="redeem-history"><span>{t('createdOn') + " " + moment(currentItem.createdOn).format('DD/MM/YYYY')}</span> <span>{t('redeemAmount') + " " + currentItem.redeemAmount + " " + currency}</span> <span>{currentItem.pmsReference ? t('pmsReference') + " " + currentItem.pmsReference : ""}</span> <span>{currentItem.propertyName ? t('inHotel') + " " + currentItem.propertyName : ""}</span></div></div>
      });
      return hisHtml;
    }
  }

  const openHitoreyRow = (clickedRow) => {
    let element = document.getElementsByClassName(clickedRow);
    if (element) {
      for (var i = 0; i < element.length; i++) {
        if (element[i].classList.contains("hidden")) {
          element[i].classList.remove("hidden");
        }
        else {
          element[i].classList.add("hidden");
        }

      }
    }

  }


  const gotoProductspage = () => {
    history.push(`/?chainid=${chainId}&lang=${lang}`);
  }

  return (
    <>
      <div className="my-account-wrap">
        <h3 aria-label={t("myAccount")}>{t("myAccount")}</h3>
        <Row>
          <Col lg="3">
            {companyUser && company ?
              <>
                <div>{company && company.companyLogoUrl ? <img className='company-logo' src={company.companyLogoUrl}></img> : <span className="greeting_txt"></span>}
                  <span
                    role="application"
                    aria-roledescription={t("greeting")}
                    aria-label={(t("hello") + " " + companyUser.customerFirstName + " " + companyUser.customerLastName + ",")}>
                    {(t("hello") + " " + companyUser.customerFirstName + " " + companyUser.customerLastName + ",")}</span> <span aria-label={t("logout")} role="button" className="logout" onClick={e => logout()}>{t("logout")}
                  </span>
                </div>
              </>
              :
              <div>
                <span className="greeting_txt"></span>
                <span role="application" aria-roledescription={t("greeting")} aria-label={thisAccountCustomer ? (t("hello") + " " + thisAccountCustomer.customerFirstName + " " + thisAccountCustomer.customerLastName + ",") : ""}>{thisAccountCustomer ? (t("hello") + " " + thisAccountCustomer.customerFirstName + " " + thisAccountCustomer.customerLastName + ",") : null}</span> <span aria-label={t("logout")} role="button" className="logout" onClick={e => logout()}>{t("logout")}</span>
              </div>
            }
            <div className="side-menu-wrap">
              <button aria-label={t("orders")} className="side-menu-item box active" onClick={e => showSection("ordersTab")}>{t("orders")}</button>
              <button aria-label={t("personalDetails")} className="side-menu-item box" onClick={e => showSection("personalDtlTab")}>{t("personalDetails")}</button>
              <button aria-label={t("contactForm")} className="side-menu-item box " onClick={e => showSection("contactformTab")}>{t("contactForm")}</button>
              <button aria-label={t("gotoProductspage")} className="side-menu-item box " onClick={e => gotoProductspage()}>{t("gotoProductspage")}</button>
            </div>

          </Col>
          <Col>
            {
              !company ?
                <div id="personalDtlTab" className="account-section hidden">
                  <h4>{t("personalDetails")}</h4>
                  <form onSubmit={handleSubmit((data) => submitForm(data))}>
                    <div className="personal-details-form-wrap box">
                      <div >
                        <Row>
                          <Col xs="12" md="6">
                            <label htmlFor="fullNameInput"> {t("FullName")}</label>
                            <input
                              name="fullNameInput"
                              {...register("fullNameInput", {
                                required: t("Required"),
                                pattern: {
                                  value: new RegExp(t("FullNameRegex")),
                                  message: t("FullNameRegexMsg"),
                                },
                              })}

                            />
                            <span className="error">{errors.fullNameInput?.message}</span>
                          </Col>
                          <Col xs="12" md="6">
                            <label htmlFor="PhoneInput"> {t("Phone")}</label>
                            <input
                              name="PhoneInput"
                              {...register("PhoneInput", {
                                required: t("Required"),
                                pattern: {
                                  value: new RegExp(t("PhoneRegex")),
                                  message: t("PhoneRegexMsg"),
                                },
                              })}

                            />
                            <span className="error">{errors.PhoneInput?.message}</span>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" md="6">
                            <label htmlFor="EmailInput"> {t("Email")}</label>
                            <input
                              name="EmailInput"
                              {...register("EmailInput", {
                                required: t("Required"),
                                pattern: {
                                  value: new RegExp(t("EmailRegex")),
                                  message: t("EmailRegexMsg"),
                                },
                              })}

                            />
                            <span className="error">{errors.EmailInput?.message}</span>
                          </Col>
                          <Col xs="12" md="6">
                            <label htmlFor="PassportInput"> {t("Passport")}</label>
                            <input
                              name="PassportInput"
                              {...register("PassportInput", {
                                required: t("Required"),

                              })}
                              disabled={thisAccountCustomer && thisAccountCustomer.customerIdentification !== "" ? 'disabled' : ''}
                            />
                            <span className="error">{errors.PassportInput?.message}</span>
                          </Col>

                        </Row>
                        <Row>
                          <Col xs="12" md="6">
                            <input
                              type="submit"
                              className="btn"
                              value={t("updateDetails")}
                            />
                          </Col>
                        </Row>


                      </div>
                    </div>
                  </form>
                  <div className={!errorMessage ? "hidden" : "error-msg box"}>
                    {errorMessage}
                  </div>

                </div>
                :
                <UserPersonalDetailsForm
                  t={t}
                  register={register}
                  submitForm={submitForm}
                  handleSubmit={handleSubmit}
                  errors={errors}
                  errorMessage={errorMessage}
                />


            }

            <div id="ordersTab" className="account-section ">
              <h4 aria-label={t("yourOrders")}>{t("yourOrders")}</h4>
              <Table hover className="ordersTable" responsive>
                <thead>
                  <tr>
                    <th>{t("orderNum")}</th>
                    <th>{t("VoucherName")}</th>
                    <th>{company ? t("VouchersCount") : t("VoucherNum")}</th>
                    <th>{t("Date")}</th>
                    <th>{t("VoucherValue")}</th>
                    <th>{t("IssuedTo")}</th>
                    <th>{t("VoucherExpiration")}</th>
                    <th>{t("VoucherLeftToRedeem")}</th>
                    <th>{company ? null : t("VoucherStatus")}</th>
                  </tr>
                </thead>
                <tbody>
                  {company ?
                    <CompanyOrders
                      allOrders={allOrders}
                      addDays={addDays}
                      getTotalRedeemedPerOrder={getTotalRedeemedPerOrder}
                      getStatusNameById={getStatusNameById}
                      getRedeemHistory={getRedeemHistory}
                      loading={loading}
                      openHitoreyRow={openHitoreyRow} />
                    :
                    allOrders.map((currentOrder, index) => {
                      return <Fragment key={index}>
                        {currentOrder.products?.map((currentProduct, ind) => {
                          return <Fragment key={ind}> <tr className="order-item " onClick={e => openHitoreyRow("hist-row-" + currentOrder.orderId)} >
                            <td aria-label={t("orderNum") + currentOrder.orderId.toString().split('').join(' ')}>{currentOrder.orderId}</td>
                            <td aria-label={"שם השובר" + currentProduct.productShortDescription ? currentProduct.productShortDescription : currentProduct.productName}> {currentProduct.productShortDescription ? currentProduct.productShortDescription : currentProduct.productName}</td>
                            <td aria-label={t("VoucherNum") + currentOrder.voucherNumber.toString().split('').join(' ')}>{currentOrder.voucherNumber}</td>
                            <td aria-label={"תאריך הרכישה" + moment(currentOrder.orderPlacementDate).format('DD/MM/YYYY')}>{moment(currentOrder.orderPlacementDate).format('DD/MM/YYYY')} </td>
                            <td aria-label={"שווי השובר" + currentProduct.price + " " + currentProduct.currencyCode.replace("ILS", "₪")}>{currentProduct.price + " " + currentProduct.currencyCode.replace("ILS", "₪")}</td>
                            <td aria-label={"שם המקבל" + currentOrder.gifteeName ? currentOrder.gifteeName : currentOrder.customer.customerFirstName + " " + currentOrder.customer.customerLastName}>{currentOrder.gifteeName ? currentOrder.gifteeName : currentOrder.customer.customerFirstName + " " + currentOrder.customer.customerLastName} </td>
                            <td aria-label={"תוקף השובר" + currentProduct.duration ? addDays(currentOrder.orderPlacementDate, currentProduct.duration) : currentProduct.productExpiryDate ? moment(currentProduct.productExpiryDate).format('DD/MM/YYYY') : ""}> {
                              currentProduct.duration || currentProduct.productExpiryDate ?
                                <Row>
                                  <Col className="expdate">
                                    <span> {currentProduct.duration ? addDays(currentOrder.orderPlacementDate, currentProduct.duration) : currentProduct.productExpiryDate ? moment(currentProduct.productExpiryDate).format('DD/MM/YYYY') : ""} </span>
                                  </Col>
                                </Row> : null
                            } </td>
                            <td aria-label={"נותר למימוש" + getTotalRedeemedPerOrder(currentOrder.RedeemItem, currentProduct.price, currentProduct.currencyCode.replace("ILS", "₪"))}> <span className="clickable">{getTotalRedeemedPerOrder(currentOrder.RedeemItem, currentProduct.price, currentProduct.currencyCode.replace("ILS", "₪"))}</span></td>
                            <td aria-label={"סטטוס" + getStatusNameById(currentOrder.orderStatusId)}>{getStatusNameById(currentOrder.orderStatusId)} </td>
                          </tr>
                            <tr><td colSpan={9}>{getRedeemHistory(currentOrder.RedeemItem, currentProduct.price, currentProduct.currencyCode.replace("ILS", "₪"))}</td></tr>
                          </Fragment>

                        })}


                      </Fragment>
                    })}
                </tbody>
              </Table>
              {!!allOrders.length &&
                <Row className="justify-content-start">
                  <Pagination className="justify-content-center">
                    <Pagination.First disabled={currentPage == 1} onClick={() => setCurrentPage(1)} />
                    <Pagination.Prev disabled={currentPage == 1} onClick={() => setCurrentPage(currentPage - 1)} />
                    {items}
                    <Pagination.Next disabled={currentPage == items.length} onClick={() => setCurrentPage(currentPage + 1)} />
                    <Pagination.Last disabled={currentPage == items.length} onClick={() => setCurrentPage(items.length)} />
                  </Pagination>
                </Row>
              }
            </div>
            <div id="contactformTab" className="account-section hidden">
              <h4>{t("contactForm")}</h4>
              <form onSubmit={handleSubmit((data) => submitContactForm(data))}>
                <div className="personal-details-form-wrap box">
                  <div >
                    <Row>
                      <Col xs="12" md="6">
                        <label htmlFor="fullNameContactInput"> {t("FullName")}</label>
                        <input
                          name="fullNameContactInput"
                          {...register("fullNameContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("FullNameRegex")),
                              message: t("FullNameRegexMsg"),
                            },
                          })}

                        />
                        <span className="error">{errors.fullNameContactInput?.message}</span>
                      </Col>
                      <Col xs="12" md="6">
                        <label htmlFor="PhoneContactInput"> {t("Phone")}</label>
                        <input
                          name="PhoneContactInput"
                          {...register("PhoneContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("PhoneRegex")),
                              message: t("PhoneRegexMsg"),
                            },
                          })}

                        />
                        <span className="error">{errors.PhoneContactInput?.message}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" md="6">
                        <label htmlFor="EmailContactInput"> {t("Email")}</label>
                        <input
                          name="EmailContactInput"
                          {...register("EmailContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("EmailRegex")),
                              message: t("EmailRegexMsg"),
                            },
                          })}

                        />
                        <span className="error">{errors.EmailContactInput?.message}</span>
                      </Col>
                      <Col xs="12" md="6">

                        <Row>
                          <Col sm={12} md={6}><label htmlFor="MessageContactInput"> {t("ContactMessage")}</label>    </Col>
                          <Col sm={12} md={6} className="botom-inputs">
                            <div className="words-counter">
                              <span className="delete" onClick={e => clearText('MessageContactInput')}>{t("delete")}</span>
                              <span id={"counter"}>0/{TextAreaMaxLength}</span>

                            </div>
                          </Col>
                        </Row>
                        <textarea className="text-area"
                          id={'MessageContactInput'}
                          onKeyUp={e => textCounter('MessageContactInput', 'counter', TextAreaMaxLength)}
                          name="MessageContactInput"
                          {...register("MessageContactInput", { maxLength: TextAreaMaxLength }, {
                            required: t("Required"),

                          })} rows="4" ></textarea>
                        <span className="error">{errors.MessageContactInput?.message}</span>
                      </Col>

                    </Row>
                    <Row>
                      <Col xs="12" md="6">
                        <input
                          type="submit"
                          className="btn"
                          value={t("send")}
                        />
                      </Col>
                    </Row>


                  </div>
                </div>
              </form>
              <div className={!errorMessage ? "hidden" : "error-msg box"}>
                {errorMessage}
              </div>
              {!company &&
                <CustomerReqTableComponent message={t("yourRequests")} allCustomerRequests={allCustomerRequests} ></CustomerReqTableComponent>
              }


            </div>
          </Col>
        </Row>
      </div>
    </>
  );

}

export default MyAccountComponent;
